import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Axios from "../../utils/Axios";
import SummaryAPI from "../../common/SummaryAPI";
import AxiosToastError from "../../utils/AxiosToastError";

const MyReviews = () => {
    const user = useSelector((state)=> state.user)
    const [reviews, setReviews] = useState([]);

    useEffect(() => { 
        const fetchReviews = async () => {
        try {
            const response = await Axios({
                ...SummaryAPI.getUserReviews,
                params: {
                    userID: user._id
                }  
            });
        setReviews(response.data.data);
        } catch (error) {
            AxiosToastError(error);
            console.log(error);
        }
    };
    if (user && user._id) {
        fetchReviews();
    }
}, [user]);
console.log("reviews", reviews);

return (
        <div className="my-reviews" style = {{ padding: "20" }}>
        <div className="movieReviewsHeading">Reviews</div>
        {reviews.map((review) => (
                        <div key={review._id} style={{
              border: "1px solid #ccc",
              borderRadius: 8,
              padding: 10,
              marginBottom: 10,
            }}>
                         <div className="movieTitle"> {review.movieTitle} </div>
                         <div className="reviewRating"> <span>Rating: {review.rating}</span>
                         </div>
                        <div className="reviewText">
                            <span>{review.review}</span>
                         </div>
                     </div>
                    ))}
        </div>
    );

}
export default MyReviews;